import { get_headers, GET_PROFILE_COMPLETION_ID, GET_APPLICATION_DOCUMENTS
} from '@/utils/constants/constants';
import alert_mixin from "@/utils/mixins/alert_mixin";
import axios from 'axios';
import FilePreviewComponent from "@/components/probaworkflows_base_components/FilePreviewComponent/FilePreviewComponent.vue";

export default {
  name: "BeneficiaryDahsboard",
  mixins: [alert_mixin],
  components: { FilePreviewComponent },

  props: {
    application_form_id: {
      type: [String, Number],
      default: null,
    },
  },

  data: () => ({
      entity_name: sessionStorage.getItem('entity_name'), 
      profile_completion_loading: false,
      profile_completion: {
        total_questions: 0,
        answered_questions: 0,
        unanswered_questions: 0,
        completion_percentage: 0,
        sections: []
      },
      recent_documents: [],
      recent_documents_loading: false,
      show_file_preview: false,
      preview_file_url: '',
      preview_file_name: ''
    }),

    mounted() {
      this.fetch_profile_completion();
      this.fetch_recent_documents();
    },

    methods:{

      fetch_profile_completion() {
        const application_form_id = Number(this.application_form_id) || Number(sessionStorage.getItem("application_form_id"));
        if (!application_form_id) return;

        this.profile_completion_loading = true;

        axios.get(GET_PROFILE_COMPLETION_ID, {
            headers: get_headers(),
            params: { application_form_id},
          })
          .then((response) => {
            if (response.data?.status === 'success' && response.data?.data) {
              this.profile_completion = { ...response.data.data };
            } else {
              this.show_error('Unexpected response from profile completion API:', response.data);
            }
          })
          .catch((error) => {
            this.show_error(
              'Error fetching profile completion:',
              error.response?.data?.message || error.message
            );
          })
          .finally(() => {
            this.profile_completion_loading = false;
          });
      },

      fetch_recent_documents() {
        const application_id = sessionStorage.getItem('application_id');
        if (!application_id) return;

        this.recent_documents_loading = true;

        axios.get(GET_APPLICATION_DOCUMENTS, {
          headers: get_headers(),
          params: { application_id },
        })
          .then((response) => {
            const docs = response.data?.data || [];

            this.recent_documents = docs
              .sort((a, b) => new Date(b.submitted_on) - new Date(a.submitted_on))
              .slice(0, 3)
              .map(doc => ({
                name: doc.file_name,
                date: new Date(doc.submitted_on).toLocaleDateString(),
                presigned_url: doc.presigned_url,
              }));
          })
          .catch((error) => {
            this.show_error('Error loading recent documents: ' + (error.response?.data?.message || error.message));
          }).finally(() => {
            this.recent_documents_loading = false;
          });
      },

      view_all_documents() {
        sessionStorage.setItem('active_tab', 'Documents');
        sessionStorage.setItem('active_master_tab', 'documents');
        sessionStorage.setItem('came_from_dashboard', 'beneficiary');

        this.$router.push({
          path: '/entity_application_overview',
          query: {
            application_id: sessionStorage.getItem('application_id'),
            entity_profile_id: sessionStorage.getItem('entity_profile_id'),
            entity_type_id: sessionStorage.getItem('entity_type_id'),
          }
        });
      },

      open_file_preview(doc) {
        this.preview_file_url = doc.presigned_url;
        this.preview_file_name = doc.name;
        this.show_file_preview = true;
      },

      close_file_preview() {
        this.show_file_preview = false;
        this.preview_file_url = '';
        this.preview_file_name = '';
      },

      complete_profile(){
        this.$router.push({
          path: '/entity_application_overview',
          query: {
            application_id: sessionStorage.getItem('application_id'),
            entity_profile_id: sessionStorage.getItem('entity_profile_id'),
            entity_type_id: sessionStorage.getItem('entity_type_id'),
          }
        });
      }
    }
};